<div class="add__action__form" [formGroup]="addActionForm">

    <div class="add__action__form__content ">
        <div class="mb-3 row">
            <div [ngClass]="!canChooseAStatus() ? 'col-6' : 'col-4'">
                <label for="action" class="input-label">Action*</label>
                <p-dropdown [options]="actionKindsOptions" [appendTo]="'body'" optionLabel="description"
                    styleClass="w-100" formControlName="action"></p-dropdown>
            </div>

            @if(canChooseAStatus()) {
            <div class="col-4">
                <label for="action" class="input-label">Statut</label>
                <p-dropdown [options]="actionStatusesOptions()" [appendTo]="'body'" styleClass="w-100"
                    formControlName="status"></p-dropdown>
            </div>
            }

            <div class="add__action__form__content__deadline" [ngClass]="!canChooseAStatus() ? 'col-6' : 'col-4'">
                <label for="deadline" class="input-label">Date d'échéance</label>
                <p-calendar formControlName="deadline" [dateFormat]="'dd/mm/yy'" [appendTo]="'body'"
                    [style]="{width: '100%'}"></p-calendar>
                @if(addActionForm.get('deadline')?.errors?.dateInThePast) {
                <idel-form-error [errorMessage]="'L\'échéance doit être dans le futur.'"></idel-form-error>
                }
            </div>
        </div>
        <div class="add__action__form__content__message mb-3">
            <label for="message" class="input-label">Message*</label>
            <textarea pInputTextarea formControlName="message" [rows]="2" [style]="{width: '100%'}"></textarea>
            @if(addActionForm.get('message')?.errors?.notEmptyString) {
            <idel-form-error [errorMessage]="'Le message ne peut pas être vide.'"></idel-form-error>
            }
            @if(addActionForm.get('message')?.errors?.minlength) {
            <idel-form-error [errorMessage]="'Le message doit contenir au moins 5 caractères.'"></idel-form-error>
            }
        </div>

        <div class="add__action__form__content__recipients mb-3">
            <label for="recipients" class="input-label">Destinataires*</label>
            @if(
            noRecipientsSelected
            ) {
            <idel-form-error [errorMessage]="'Veuillez sélectionner au moins un destinataire.'"></idel-form-error>
            }
            <i-tabs [items]="recipientsTabs()" (tabChange)="onActiveTabChange($event)"></i-tabs>
            <div style="max-height: 40dvh; overflow-y: auto;" class="mt-2">
                @if(activeRecipientTab() ==='users') {
                <idel-checkable-list [(items)]="usersOptions" [itemLabel]="['nom', 'prenom']"
                    (onCheck)="onRecipientCheck($event)"></idel-checkable-list>
                }
                @else if(activeRecipientTab() === 'groups') {
                <idel-checkable-list [(items)]="groupsOptions" [itemLabel]="'description'"
                    (onCheck)="onRecipientCheck($event)"></idel-checkable-list>
                }
                @else if(activeRecipientTab() === 'services') {
                <idel-checkable-list [(items)]="servicesOptions" [itemLabel]="'description'"
                    (onCheck)="onRecipientCheck($event)"></idel-checkable-list>
                }
            </div>
        </div>

        <div class="add_action__form__buttons d-flex w-100 justify-content-end gap-2">
            <i-button [styleClass]="'green'" [text]="'Demander'" [disabled]="addActionForm.invalid"
                [iconPosition]="'left'" [loading]="creatingAction()" [icon]="'bi bi-plus-circle-fill'"
                (click)="onCreateActionClick()"></i-button>
        </div>

    </div>

</div>